var searchesID = "AA_FlightSearch";

function getRecentSearchesFromLS() {
    moveRecentSearchesFromCookieToLS();
    var recentSearches = [];
    if (window['localStorage'] !== null) {
        var searches = localStorage.getItem(searchesID);
        if (searches != null && searches != "") {
            recentSearches = JSON.parse(searches);
        }
        else {
        	recentSearches = [];
        }
    }
    else {
        recentSearches = [];
    }
    return recentSearches;
}

function saveRecentSearchesToLS(recentSearches){
    localStorage.setItem(searchesID, recentSearches);
    return;
}

function deleteRecentSearchesFromLS(){
    localStorage.removeItem(searchesID);
    return;
}

function submitSearch(currentSearch) {
    try {
        saveRecentSearchesToLS(JSON.stringify(updateRecentSearches(currentSearch, getRecentSearchesFromLS())));
    }
    catch (err) {
        console.log("Failed to add current search to LS.");
    }
    return;
}

function moveRecentSearchesFromCookieToLS(){
    var aaCookieSearches = jQuery.aaCookie.get(searchesID);
    if (aaCookieSearches != null) {
        if (aaCookieSearches.length > 0) {
            saveRecentSearchesToLS(aaCookieSearches);
        }
        document.cookie = searchesID + '="";-1; path=/';
    }
}

function getCurrentSearch() {
    var isMobile = $j('.mobile-tab-container').length > 0;
    
    const originAirport = isMobile ? $j('#segments0\\.origin').val() : $j('#reservationFlightSearchForm\\.originAirport').val();
    const destinationAirport = isMobile ? $j('#segments0\\.destination').val() : $j('#reservationFlightSearchForm\\.destinationAirport').val();
    const originTravelDate = isMobile ? $j('#departDate').val() : $j('#aa-leavingOn').val();
    const destinationTravelDate = isMobile ? $j('#returnDate').val() : $j('#aa-returningFrom').val();
    const tripType = isMobile ? getMobileCurrentTripType() : getSelectedFindFlightType();
    const awardBooking = isMobile ? $j('#awardBooking2').prop('checked') : $j('#flightSearchForm\\.tripType\\.redeemMiles').prop('checked');

    var currentSearch = {
        elementID: "",
        originAirport: originAirport,
        originTravelDate: originTravelDate,
        destinationAirport: destinationAirport,
        destinationTravelDate: destinationTravelDate,
        createDate: new Date(),
        tripType: tripType,
        awardBooking: awardBooking,
        expired: false
    };

    return currentSearch;
}

function getSelectedFindFlightType() {
    if ($j('#flightSearchForm\\.tripType\\.oneWay').prop('checked')) {
        return "oneWay";
    }
    return "roundTrip";
}

function getMobileCurrentTripType() {
    var tripType = $j('#flightTripType > .ui-state-active').get(0).id;
    switch (tripType) {
        case 'OneWay':
            return 'oneWay';
        case 'RoundTrip':
            return 'roundTrip';
        case 'MultiCity':
            return 'multiCity';
    }
}
